export function qualityToColor(quality: string) {
  return quality === "Bad"
    ? "primary.main"
    : quality === "Medium"
    ? "yellow.light"
    : "green.light";
}
